export const ALCOHOL="ALCOHOL"
export const DRINK="DRINK"
export const REMOVEALCOHOL="REMOVEALCOHOL"
export const REMOVEDRINK="REMOVEDRINK"
export const LOADING="LOADING"
export const STOPLOADING="STOPLOADING"
